import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import RedeemOutlinedIcon from '@mui/icons-material/RedeemOutlined'
import type { SvgIconComponent } from '@mui/icons-material';

interface Vantagem {
  Icone: SvgIconComponent
  texto: string
}

/** O que o cliente ganha entrando. */
const VANTAGENS: ReadonlyArray<Vantagem> = [
  { Icone: ReceiptLongIcon, texto: 'Acompanhe o pedido e veja seu histórico' },
  { Icone: PlaceOutlinedIcon, texto: 'Endereços salvos para pedir mais rápido' },
  { Icone: CreditCardIcon, texto: 'Pague com cartão online e salve seus cartões' },
  { Icone: LocalOfferOutlinedIcon, texto: 'Use cupons exclusivos para clientes' },
];

/** Só entra na lista em loja que aceita cashback como desconto: sem isso, seria promessa que o checkout não cumpre. */
const VANTAGEM_CASHBACK: Vantagem = { Icone: RedeemOutlinedIcon, texto: 'Use seu cashback nos pedidos' }

interface Props {
  onEntrar: () => void;
  onSemLogin: () => void;
  /** A loja aceita cashback como desconto (`cashbackUsoAtivo` da configuração). Sem a prop, vale como não. */
  lojaAceitaCashback?: boolean
}

/**
 * Início do checkout de delivery quando a loja aceita pedido sem login: entrar é
 * o caminho destacado; seguir sem conta fica disponível, mas discreto.
 */
export function EscolhaEntrar({ onEntrar, onSemLogin, lojaAceitaCashback = false }: Props): JSX.Element {
  const vantagens = lojaAceitaCashback ? [...VANTAGENS, VANTAGEM_CASHBACK] : VANTAGENS

  return (
    <Stack spacing={2}>
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          borderColor: 'primary.main',
          bgcolor: (t) => alpha(t.palette.primary.main, 0.04),
        }}
      >
        <Typography variant="subtitle1" fontWeight={700} gutterBottom>
          Entre na sua conta
        </Typography>
        <Stack spacing={1.25} sx={{ mb: 2 }}>
          {vantagens.map(({ Icone, texto }) => (
            <Stack key={texto} direction="row" spacing={1.5} alignItems="center">
              <Box sx={{ color: 'primary.main', display: 'flex' }}>
                <Icone fontSize="small" />
              </Box>
              <Typography variant="body2">{texto}</Typography>
            </Stack>
          ))}
        </Stack>
        <Button variant="contained" size="large" fullWidth disableElevation onClick={onEntrar}>
          Entrar
        </Button>
      </Paper>
      <Box sx={{ textAlign: 'center' }}>
        <Button color="inherit" onClick={onSemLogin} sx={{ color: 'text.secondary', textDecoration: 'underline' }}>
          Continuar sem login
        </Button>
        <Typography variant="caption" color="text.secondary" display="block">
          Sem login, o pagamento é feito na entrega.
        </Typography>
      </Box>
    </Stack>
  );
}
